/**
 * Status Category Codes
 *
 * Represents the category that a status belongs to.
 * These are system-wide constants, not tenant-specific.
 *
 * Mirrors backend StatusCategory enum codes.
 */
export enum StatusCategoryCode {
  Open = 'Open',
  InProgress = 'InProgress',
  Pending = 'Pending',
  Resolved = 'Resolved',
  Closed = 'Closed',
}
